<template>
  <v-container
    class="fill-height"
    fluid
  >
    <v-row
      align="center"
      justify="center"
    >
      <v-col>
        <v-card
          class="mx-auto landing-card"
          max-width="950"
        >
          <v-card-title class="bg-primary d-flex align-center">
            <div class="banner-side d-flex align-center">
              <img
                :src="logoPath"
                alt="BC Whales Logo"
                class="appbar-vertical-align logo"
              >
            </div>
            <span
              class="text-h4 white-text text-center"
              style="word-break: break-word"
            >
              BCWhales Database Portal
            </span>
            <div class="banner-side" />
          </v-card-title>
          <v-divider />
          <v-card-text class="text-center">
            <v-row
                justify="center"
                class="submit-button-caption"
            >
              <v-col>
                    <span class="text-h5">
                      Welcome to the BCWhales Database Portal
                    </span>
              </v-col>
            </v-row>
            <v-row
                justify="center"
                class="submit-button-caption"
            >
              <v-col>
                <span class="text-body-1">
                  This database is for internal use only. If you wish to report an incident involving a marine mammal, please
                  see visit our
                </span>
                <a class="text-body-1" href="https://bcwhales.org/incident-reporter"> incident reporting site.</a>
                <span class="text-body-1">
                      Otherwise, visit our homepage at
                </span>
                <a class="text-body-1" href="https://bcwhales.org"> https://bcwhales.org</a>
                <span class="text-body-1">
                      to learn more about our work.
                </span>
              </v-col>
            </v-row>
          </v-card-text>
          <v-spacer/>
          <v-card-actions class="landing-card-actions">
            <v-row class="pb-1">
              <v-spacer></v-spacer>
              <v-btn
                  variant="text"
                  color="primary"
                  to="/login"
                  class="ma-2"
              >
                <span>Staff Log In</span>
              </v-btn>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
// import HumpbackLogo from "@/components/svgs/HumpbackLogo";
import {useDisplay} from "vuetify"
import {ref} from "vue";
// import "element-plus/theme-chalk/display.css";

export default {
  // components: {
  //   HumpbackLogo,
  // },

  data() {
    return {
      logoPath: "/BC_Whales_Logo_White_Primary.png",
      email: "",
      password: "",
      forgotPasswordPath: "/forgotPassword",
    };
  },
  computed: {
    ...mapGetters({
      loading: "auth/loading",
      isTokenSet: "auth/isTokenSet",
      message: "auth/message",
      role: "auth/role",
    }),
    isMobile() {
      const display = ref(useDisplay());
      return display.value.mdAndDown;
    },
  },
  created() {
    this.reset();
    if (this.isTokenSet) {
      if (this.role === "admin") {
        this.$router.push({name: "sightings"});
      }
      this.$router.push({name: "sightings"});
    }
  },
  methods: {
    ...mapActions({
      reset: "auth/reset",
      login: "auth/login",
    }),
    async submit() {
      await this.login({
        email: this.email,
        password: this.password,
      });
      this.password = null;
    },
  },
};
</script>

<style scoped>
.submit-button {
  font-size: large;
}
.landing-card-actions {
  margin-top: 100px;
}
.appbar-vertical-align {
  vertical-align: middle;
}
.logo {
  height: 4rem;
  width: auto;
}
.banner-side {
  flex: 1 1 0;
}
</style>
